
function currencyFormat(num) {
     const options = { maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'EUR', currencyDisplay: "code" };
    return Intl.NumberFormat("it-IT", options).format(num).replace("EUR", "").trim();
  }
export default currencyFormat;